import useBindActionCreators from 'common/hooks/useBindActionCreators';

import { brandsOperations } from '../store';

export const useBrandsOperations = (): typeof brandsOperations => {
  const bindedActions = useBindActionCreators(brandsOperations);
  return bindedActions;
};
